import { render, staticRenderFns } from "./releaseForm.vue?vue&type=template&id=3b28a496"
import script from "./releaseForm.vue?vue&type=script&lang=js"
export * from "./releaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports